import styled from 'styled-components';
import { Link as RRDLink } from '@/providers/RouterShim';

import { size } from '../../layout/helpers';

export const Breadcrumb = styled.div`
  --breadcrumb-overflow-width: ${size(3)};

  overflow: hidden;
  position: relative;
  width: 100%;

  :after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;
    background-color: var(--c-bg-main);
    mask-image: ${(props) => props.theme.mask.gradient.toLeft};
    width: var(--breadcrumb-overflow-width);
    bottom: 0;
  }
`;

export const BreadcrumbList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  overflow: auto;

  &::after {
    content: '';
    flex-shrink: 0;
    width: var(--breadcrumb-overflow-width);
    height: 1px;
  }
`;

export const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  color: var(--c-text-muted);
  white-space: nowrap;

  & + & {
    &::before {
      content: '/';
      padding: 0 ${size(0.5)};
      color: var(--c-text-main);
    }
  }
`;

export const BreadcrumbLink = styled(RRDLink)`
  color: var(--c-text-main);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus,
  &:focus-visible {
    outline: none;
  }

  @supports selector(:focus-visible) {
    &:focus-visible {
      color: var(--c-focus);
      text-decoration: underline;
    }
  }

  // Safari & IE11
  @supports not selector(:focus-visible) {
    &:focus {
      color: var(--c-focus);
      text-decoration: underline;
    }
  }
`;
